export const APP_VERSION = '1.0.2';


// WEBPACK FOOTER //
// ./src/libs/config.js